import clsx from 'clsx';
import React, { FC, useMemo } from 'react';
import { Question } from 'schema-dts';

import Accordion, { type AccordionProps } from '../accordion';
import JsonLd from '../JsonLd';

export type FaqItemProps = AccordionProps & {
  jsonLdQuestion?: string;
  jsonLdAnswer?: string;
  onlyAccordion?: boolean;
};

const FaqItem: FC<FaqItemProps> = ({
  heading,
  items,
  isMultiple,
  isNarrow,
  className,
  jsonLdAnswer,
  jsonLdQuestion,
  hasShowMore,
  onlyAccordion,
}) => {
  const baseClassName = clsx(
    'col-end-24 col-start-2 row-end-2 row-start-2 lg:row-end-1 lg:row-start-1',
    !onlyAccordion && 'lg:col-start-11 lg:col-end-23'
  );

  const meta: Question = useMemo(
    () => ({
      '@context': 'https://schema.org',
      '@type': 'Question',
      name: jsonLdQuestion,
      acceptedAnswer: {
        '@type': 'Answer',
        text: jsonLdAnswer,
      },
    }),
    [jsonLdAnswer, jsonLdQuestion]
  );

  return (
    <>
      <Accordion
        heading={heading}
        items={items}
        isMultiple={isMultiple}
        isNarrow={isNarrow}
        className={className + ' ' + baseClassName}
        hasShowMore={hasShowMore && items?.length > 5}
        component={''}
        _uid={''}
      />
      <JsonLd value={meta} />
    </>
  );
};

export default FaqItem;
